import { ApiBase } from "./api-base";

export class HttpAiApi extends ApiBase {
  onApiName(): string {
    return "AiApi";
  }

  onUrlPath(): string {
    return "";
  }

  public async postStream(param: any) {
    const response = await this.requestStream(param);
    return response.body;
  }

  public async genStreamResponse(streamRes: ReadableStream) {
    const reader = streamRes?.getReader();
    const decoder = new TextDecoder();

    let done = false;
    let content = "";

    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading; // 스트림 완료시 true
      const chunkValue = decoder.decode(value);
      content = content + chunkValue;
    }
    try {
      const payload: any = JSON.parse(content);

      return payload;
    } catch (error) {
      return { code: "500", response: { error_msg: "json parse error" } };
    }
  }
}
